import type { FC } from 'react';
import { TextLink as TextLinkHebe } from '@sbt-web/ancillary-services';
import { useViewport } from '@sbt-web/hooks';
import type { AdItem } from '@sbt-web/network/types';
import { prepareRemoteDataAdDetail } from '@/shared/helpers/Hebe';
import { getOrCreatePulse } from '@/tools/tracking/utils';

const TextLinkBox: FC<{
  item: AdItem;
}> = (props) => {
  const { isMobile } = useViewport();
  const { item } = props;

  return (
    <TextLinkHebe
      item={item}
      pulseInstance={getOrCreatePulse()}
      remoteData={prepareRemoteDataAdDetail('ASIDE', item, isMobile)}
    />
  );
};

export default TextLinkBox;
